export enum FirebaseEventNameEnum {
  NAV_LINKS = 'nav-links',
  CLICK = 'click',
  CHANGE_LANGUAGE = 'change-language',
}
